import { createFormFieldConfig } from './createFormField';

export const formViewCO = {
  STEP_1: {
    fullName: createFormFieldConfig('fullName', 'placeholderReferralFullName', 'labelReferralFullName', 'fullName'),
    documentType: createFormFieldConfig('rfc', 'placeholderCC', 'labelCC', 'rfc'),
    email: createFormFieldConfig('email', 'placeholderEmailSpanish', 'columnEmail', 'email'),
    fullAddress: createFormFieldConfig('fullAddress', 'placeholderReferralFullAddress', 'labelReferralFullAddress', 'fullAddress'),
  },
  STEP_2: {
    sectionInfoBank: true,
    commercialNameInput: createFormFieldConfig('commercialName', 'placeholderCommercialNamePE', 'labelCommercialName'),
    companyRFCInput: createFormFieldConfig('rfc', 'placeholderCompanyRuTCO', 'labelCompanyRutCO'),
    fullAddressInput: createFormFieldConfig('fullAddress', 'placeholderReferralFullAddress', 'labelReferralFullAddress'),
    dropFileInput: createFormFieldConfig('proofOfTaxSituation', 'labelProofOfTaxSituationPE', 'labelProofOfTaxSituationPE', null, null, false, {
      label: 'labelDropZoneOlaClick',
      maxSize: 'labelDropZoneOlaClickMaxSize',
    }),
    companyLegalNameInput: createFormFieldConfig('legalName', 'placeholderCompanyLegalName', 'labelCompanyLegalName'),
    countryInput: createFormFieldConfig('country', 'placeholderCountrySpanish', 'labelCountrySpanish'),
    clabeInput: createFormFieldConfig('clabe', 'placeholderCompanyCLABE', 'labelCompanyCLABE', null, null, false, null, false),
    webInput: createFormFieldConfig('web', 'placeholderCompanyWebsite', 'labelCompanyWebSite'),
    cityInput: createFormFieldConfig('city', 'placeholderCityPE', 'labelReferralSpanishCity'),
    zipCodeInput: createFormFieldConfig('zipCode', 'placeholderZipCode', 'labelZipCode'),
    bankInput: createFormFieldConfig('bank', 'labelBankNameOlaClick', 'labelBankOlaClick'),
    accountInput: createFormFieldConfig('clabe', 'placeholderAccountPE', 'labelAccountNumberCO'),
    bankAccountCodeInput: createFormFieldConfig('accountType', 'placeholderBankAccountTypeCO', 'labelBankAccountTypeCO'),
    companyNITInput: createFormFieldConfig('nit', 'placeholderNit', 'labelNit'),
  },
};
